import { ReactNode } from 'react'
import styled from 'styled-components'
import useWindowWidth from '../../../utils/use.window.width'

const CardWrapper = styled.div`
	position: relative;

	filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 0.25));
	margin: 20px 10px;
	display: inline-block;
	vertical-align: top;

	@media (max-width: 1024px) {
		width: 356px;
		height: 241px;
	}
`

const NumberBadge = styled.div`
	position: absolute;
	top: 25px;
	right: -36px;
	width: 110px;
	height: 110px;
	background-color: #01924f;
	border-radius: 18px;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 10;
	font-family: 'e-Ukraine-Head', sans-serif;
	font-weight: 700;
	font-size: 63px;
	color: #fff;
	text-shadow: inset 0 4px 4px 0 rgba(0, 0, 0, 0.25);

	&::after {
		content: '';
		position: absolute;
		bottom: -10px;
		left: 50%;
		transform: translateX(-50%);
		border-left: 12px solid transparent;
		border-right: 12px solid transparent;
		border-top: 14px solid #01924f;
	}

	@media (max-width: 1240px) {
		top: 40px;
		right: 0px;
		width: 90px;
		height: 90px;
		font-size: 45px;
	}

	@media (max-width: 1024px) {
		top: 25px;
		right: 0px;
		width: 110px;
		height: 110px;
		font-size: 63px;
	}
`
const MOBILE_MASK = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 356 300'%3E%3Cpath d='M7.199 22.199C7.199 13.363 14.363 6.199 23.199 6.199H205.699C214.536 6.199 221.699 13.363 221.699 22.199V124.699C221.699 133.536 228.863 140.699 237.699 140.699H320.199C329.036 140.699 336.199 147.863 336.199 156.699V263.699C336.199 272.536 329.036 279.699 320.199 279.699H23.199C14.363 279.699 7.199 272.536 7.199 263.699V22.199Z' fill='%23000'/%3E%3C/svg%3E")`
const ShapeContent = styled.div`
	position: relative;
	background-color: #f8f8f8;
	padding: 30px 25px;
	min-height: 333px;
	width: 100%;
	display: flex;
	flex-direction: column;

	mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 278 280'%3E%3Cpath d='M4.029 17v239.5c0 4 2 7.5 4.5 10 2.5 2.5 6.165 4.667 7.5 5h118.029h7.472h8.528c30.333-.167 91.899-.6 95.499-1 4.5-.5 7-2.5 9-4 1.6-1.2 2.667-6.167 3-8.5V200l15.473-13.5-15.473-11V89c0-3.5-1-7-4-10.5-2.4-2.8-6.333-3.5-8-3.5h-99.499c-2 0-5.5-2.5-7-4-1.5-1.5-4-4-4.5-8-.167-15-.6-45-1-47.4-.5-3-2.5-5.5-4.5-8-1.6-2-6-3.167-8-3.5H16.027c-1.5.167-5.298 1.4-8.498 5-3.2 3.6-3.667 9.5-3.5 12z' fill='%23000'/%3E%3C/svg%3E");

	-webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 278 280'%3E%3Cpath d='M4.029 17v239.5c0 4 2 7.5 4.5 10 2.5 2.5 6.165 4.667 7.5 5h118.029h7.472h8.528c30.333-.167 91.899-.6 95.499-1 4.5-.5 7-2.5 9-4 1.6-1.2 2.667-6.167 3-8.5V200l15.473-13.5-15.473-11V89c0-3.5-1-7-4-10.5-2.4-2.8-6.333-3.5-8-3.5h-99.499c-2 0-5.5-2.5-7-4-1.5-1.5-4-4-4.5-8-.167-15-.6-45-1-47.4-.5-3-2.5-5.5-4.5-8-1.6-2-6-3.167-8-3.5H16.027c-1.5.167-5.298 1.4-8.498 5-3.2 3.6-3.667 9.5-3.5 12z' fill='%23000'/%3E%3C/svg%3E");
	mask-size: 100% 100%;
	mask-repeat: no-repeat;
	-webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 278 333'%3E%3Cpath d='M4.029 17v292.5c0 4 2 7.5 4.5 10 2.5 2.5 6.165 4.667 7.5 5h118.029h7.472h8.528c30.333-.167 91.899-.6 95.499-1 4.5-.5 7-2.5 9-4 1.6-1.2 2.667-6.167 3-8.5V249l15.473-13.5-15.473-11v-87c0-3.5-1-7-4-10.5-2.4-2.8-6.333-3.5-8-3.5h-99.499c-2 0-5.5-2.5-7-4-1.5-1.5-4-4-4.5-8-.167-32.333-.6-97.6-1-100-.5-3-2.5-5.5-4.5-8-1.6-2-6-3.167-8-3.5H16.027c-1.5.167-5.298 1.4-8.498 5-3.2 3.6-3.667 9.5-3.5 12z' fill='%23000'/%3E%3C/svg%3E");
	-webkit-mask-size: 100% 100%;

	@media(max-width: 1240px) {
	  padding: 30px 15px;
	}
	


@media (max-width: 1024px) {
  mask-image: ${MOBILE_MASK};
  -webkit-mask-image: ${MOBILE_MASK};
  mask-size: 100% 100%;
  -webkit-mask-size: 100% 100%;
  width: 356px;
  padding: 20px;
  box-sizing: border-box;
}}
`

const SideTail = styled.div`
	position: absolute;
	right: -8px;
	top: 65%;
	width: 20px;
	height: 20px;
	background: #f8f8f8;
	transform: rotate(45deg);
	border-radius: 4px;
	z-index: 1;

	@media (max-width: 1024px) {
		display: none;
	}
`

const IconBox = styled.div`
	width: 65px;
	height: 65px;
	margin-top: 34px;
	margin-bottom: 50px;
	padding: 0px 15px;
	color: #01924f;
	svg {
		width: 100%;
		height: 100%;
	}

	@media (max-width: 1024px) {
		padding: 0px;
		margin-top: 0px;
		margin-bottom: 0;
		width: 55px;
		img {
			width: 40px;
			height: 40px;
		}
	}
`

export const CardHeader = styled.div`
	display: flex;
	margin-top: 45px;
	margin-bottom: 25px;
`

interface StepCardProps {
	number: string | number
	icon: ReactNode
	title: string
	children?: ReactNode
}

export const StepCard = ({ number, icon, title, children }: StepCardProps) => {
	const windowWidth = useWindowWidth()
	const isMobile = windowWidth <= 1024
	return (
		<CardWrapper>
			<NumberBadge>{number}</NumberBadge>
			{!isMobile && <SideTail />}

			<ShapeContent>
				{isMobile ? (
					<CardHeader>
						<IconBox>{icon}</IconBox>
						<Title>{title}</Title>
					</CardHeader>
				) : (
					<>
						<IconBox>{icon}</IconBox>
						<Title>{title}</Title>
					</>
				)}
				{children}
			</ShapeContent>
		</CardWrapper>
	)
}

const Title = styled.h2`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 700;
	font-size: 16px;
	letter-spacing: -0.02em;
	color: #01924f;
	margin: 0;
	line-height: 1.2;
	max-width: 210px;

	@media (max-width: 1024px) {
		max-width: 145px;
	}
`
